import * as Sentry from '@sentry/browser';
import { WebSocketAccessTokenError } from './errors';
import meta from './meta';

const initSentry = (sentryDsn, releaseName, appEnv) => {
  const dsn = sentryDsn || meta('sentry_dsn');
  if (dsn) {
    Sentry.init({
      dsn,
      release: releaseName || 'latest',
      environment: appEnv || meta('sentry_env'),
      beforeSend(event, hint) {
        const error = hint.originalException;
        if (error instanceof WebSocketAccessTokenError) return null;
        return event;
      },
    });
  }
};

const setSentryUser = user => {
  Sentry.configureScope(scope => {
    scope.setUser({ id: user.id, email: user.email, username: user.fullname });
  });
};

const logErrorMessage = message => {
  Sentry.captureMessage(message);
};

export { initSentry, setSentryUser, logErrorMessage };
